
import { Component, Vue } from "vue-property-decorator"
import { State } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import ScrollTabs from "@/components/Controls/Tabs/ScrollTabs.vue"
import ScrollTab from "@/components/Controls/Tabs/ScrollTab.vue"
import { IntegrationSummary } from "@/types/integration"

import IntegrationView from "@/components/Integrations/IntegrationView.vue"
import PageWrapper from "@/components/New/Page/PageWrapper.vue"

@Component({
	components: {
		"page": PageWrapper,
		"scrollbar": VuePerfectScrollbar,
		"scroll-tab": ScrollTab,
		"scroll-tabs": ScrollTabs,
		"integration-view": IntegrationView
	}
})
export default class Integrations extends Vue {
	@State integrations!: IntegrationSummary[]
}

